import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿En qué formato viene el ebook y cómo lo recibo?',
  a: 'El ebook "Di Esto, No Aquello™" viene en formato PDF, compatible con cualquier dispositivo (celular, tablet, computadora). Lo recibes inmediatamente en tu correo electrónico después de completar la compra. No tienes que esperar nada — lo descargas y empiezas a leer en minutos.'
}, {
  q: '¿Esto realmente funciona o es solo teoría?',
  a: 'Este NO es un libro de teoría. Es 100% práctico. Cada capítulo incluye frases exactas, scripts listos para copiar y pegar, y ejemplos reales de conversaciones. Miles de mujeres ya lo están usando diariamente para comunicarse mejor con sus parejas, y los resultados hablan por sí solos.'
}, {
  q: '¿Sirve si mi relación ya está muy dañada?',
  a: 'Sí. De hecho, muchas de las mujeres que más resultados han tenido estaban en relaciones con comunicación muy deteriorada. Las frases están diseñadas precisamente para esos momentos difíciles — cuando sientes que nada funciona y que él no te escucha. No es magia, pero sí es una herramienta poderosa para cambiar la dinámica.'
}, {
  q: '¿Y si no tengo pareja actualmente?',
  a: 'Este ebook te prepara para cualquier relación presente o futura. Las habilidades de comunicación que aprenderás aplican también con familiares, amigos, compañeros de trabajo y en el dating. Muchas lectoras solteras lo usan para establecer límites saludables desde el inicio.'
}, {
  q: '¿Funciona si él es muy cerrado o no quiere hablar?',
  a: 'Absolutamente. Uno de los bonos incluidos se llama "Qué Decir Cuando Él Se Cierra™" y está diseñado exactamente para esa situación. Aprenderás frases que abren la conversación sin presionar, sin atacar y sin que él se sienta acorralado. Es uno de los recursos más valorados del paquete.'
}, {
  q: '¿Es solo para relaciones románticas?',
  a: 'No. Aunque el enfoque principal es la comunicación en pareja, las técnicas y scripts funcionan en cualquier relación donde necesites expresarte con claridad y calma: con tu mamá, tu hermana, tu jefa, tus amigas. Comunicarte bien es una habilidad que transforma todas tus relaciones.'
}, {
  q: '¿Qué incluyen los 3 bonos gratis?',
  a: 'Recibes tres recursos adicionales sin costo: (1) La Guía de Mensajes Calmantes™ con 25 mensajes listos para WhatsApp, (2) "Qué Decir Cuando Él Se Cierra™" con estrategias para romper el silencio, y (3) Scripts de Emergencia™ con frases para momentos de alto estrés. Juntos valen más de $60, pero hoy los recibes gratis con tu compra.'
}, {
  q: '¿Es seguro pagar aquí? ¿Mis datos están protegidos?',
  a: 'Totalmente. Usamos encriptación SSL de 256 bits, el mismo nivel de seguridad que usan los bancos. Tu información de pago nunca se almacena en nuestros servidores. Además, no aparecerá ningún nombre comprometedor en tu estado de cuenta.'
}, {
  q: '¿Qué pasa si no me gusta o no me funciona?',
  a: 'Tienes una garantía de satisfacción de 7 días. Si por cualquier razón sientes que el ebook no es para ti, simplemente nos escribes y te devolvemos el 100% de tu dinero. Sin preguntas, sin complicaciones. Tu inversión está completamente protegida.'
}, {
  q: '¿Por qué cuesta solo $9.99 si incluye tanto?',
  a: 'Porque nuestra misión es que la mayor cantidad de mujeres posible tenga acceso a estas herramientas. Sabemos que muchas están pasando por momentos difíciles y no pueden invertir cientos de dólares en terapia. Este precio es temporal y es nuestra forma de hacer que el cambio sea accesible para todas.'
}, {
  q: '¿Puedo compartirlo con una amiga?',
  a: 'El ebook es para uso personal. Pero si tienes una amiga que lo necesita (y seguro la tienes 😊), puedes enviarle el enlace para que ella también lo obtenga al precio especial. ¡Imagina tener a alguien con quien practicar las frases juntas!'
}, {
  q: '¿En qué idioma está el contenido?',
  a: 'Todo el contenido está 100% en español, escrito pensando en mujeres latinas que viven en Estados Unidos. El lenguaje es cercano, claro y sin tecnicismos. Como si una amiga que te entiende te estuviera dando los mejores consejos.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <Section background="white" id="faq" data-id="element-44">
      <div className="max-w-3xl mx-auto" data-id="element-45">
        <div className="text-center mb-12" data-id="element-46">
          <span className="text-rose-600 font-bold tracking-wider text-sm uppercase mb-2 block" data-id="element-47">
            Resolvemos tus dudas
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-48">
            Preguntas Frecuentes
          </h2>
          <p className="mt-4 text-gray-600" data-id="element-49">
            Todo lo que necesitas saber antes de tomar la mejor decisión para tu
            comunicación.
          </p>
        </div>

        <div className="space-y-3" data-id="element-50">
          {faqs.map((faq, index) => <div key={index} className={`
                rounded-xl border transition-colors duration-200
                ${openIndex === index ? 'border-rose-200 bg-rose-50/40' : 'border-gray-200 bg-white'}
              `} data-id="element-51">
              <button onClick={() => toggle(index)} className="w-full flex items-center justify-between gap-4 p-5 text-left" aria-expanded={openIndex === index} data-id="element-52">
                <span className={`font-semibold text-sm md:text-base ${openIndex === index ? 'text-rose-700' : 'text-gray-900'}`} data-id="element-53">
                  {faq.q}
                </span>
                <ChevronDown className={`h-5 w-5 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180 text-rose-500' : 'text-gray-400'}`} data-id="element-54" />
              </button>
              <div className={`
                  overflow-hidden transition-all duration-300 ease-in-out
                  ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}
                `} data-id="element-55">
                <div className="px-5 pb-5 text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-4" data-id="element-56">
                  {faq.a}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
}